<div class="d-flex justify-content-center">
  <div class=" simple-navbar d-flex justify-content-between align-items-center">

    <!-- Logo -->
    <div class="logo d-none d-md-block" [routerLink]="'/home'">
      <img src="./assets/images/clockflex-logo.svg" alt="ClockFlex Logo" class="logo-desktop">
    </div>

    <div class="logo d-block d-md-none" [routerLink]="'/home'">
      <img src="./assets/images/c.svg" alt="ClockFlex Logo" class="logo-mobile">
    </div>

    <!-- Navigation -->
    <div class="d-flex align-items-center">

      <button class="btn btn-link nav-link-btn" [routerLink]="'/pricing'">
        {{ 'PRICING' | translate }}
      </button>

      <button class="btn btn-link nav-link-btn d-none d-md-inline-block" [routerLink]="'/blogs'">
        {{ 'BLOGS' | translate }}
      </button>

      <button class="btn btn-link nav-link-btn d-none d-md-inline-block" [routerLink]="'/features'">
        {{ 'FEATURES' | translate }}
      </button>

      @if (isLoggedIn) {
      <a [routerLink]="'/app'" class="btn btn-dark btn-sm get-started-btn me-3">
        {{ 'GET_STARTED' | translate }}
      </a>
      }

      @if (!isLoggedIn) {
      <button class="btn btn-link nav-link-btn" [routerLink]="'/auth/login'">
        {{ 'LOGIN' | translate }}
      </button>
      }

      @if (isLoggedIn) {
      <app-user-circle [user]="user"></app-user-circle>
      }

    </div>

  </div>
</div>